import { create } from "zustand";
import { combine } from "zustand/middleware";
import { defaultThemeVariables } from "./defaultThemeVariables";

export const useEmailThemeStore = create(
  combine(
    {
      /** @TODO IRL there would be a theme added on top and we would derive it from a combination of default and theme */
      defaultThemeVariables,
    },
    () => ({}),
  ),
);
